<template>
  <div>
    <div class="CalendarGuideStep-title">{{ header }}</div>
    <div class="CalendarGuideStep-label">{{ label }}</div>
    <div v-if="link" class="CalendarGuideStep-link" @click="copyLink(link)">
      <div class="CalendarGuideStep-link-icon pa-6">
        <v-icon class="Section-icon">mdi-file-multiple</v-icon>
      </div>
      <div class="CalendarGuideStep-link-url">
        {{ link }}
      </div>
    </div>
    <div v-if="showTooltip">
      <v-alert type="sucess" color="primary" text dense>
        {{ $t('manage.bookingForm.copyMessage') }}
      </v-alert>
    </div>
    <div v-if="image" class="CalendarGuideStep-image">
      <img :src="image" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'CalendarGuideStep',
  props: {
    header: {
      type: String,
      required: true
    },
    image: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      required: true
    },
    link: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showTooltip: false
    }
  },
  methods: {
    copyLink(link) {
      navigator.clipboard.writeText(link)
      this.showTooltip = true
      setTimeout(() => (this.showTooltip = false), 2500)
    }
  }
}
</script>

<style lang="scss" scoped>
.CalendarGuideStep-title {
  color: var(--v-primaryAccent-base);
  font-size: 24px;
  font-weight: 900;
  line-height: 28px;
  margin-bottom: 7px;
}

.CalendarGuideStep-label {
  color: var(--v-text-base);
  font-size: 18px;
  font-weight: 900;
}

.CalendarGuideStep-link {
  margin: 15px 0;
  padding: 10px 15px;
  background-color: var(--v-secondary-lighten1);
  transition: 0.35s;
  cursor: pointer;
  &:hover {
    background-color: var(--v-secondary-lighten2);
  }
}

.CalendarGuideStep-link {
  display: inline-grid;
  align-items: center;
  grid-template-columns: 80px 1fr;
  width: 100%;
}

.CalendarGuideStep-link-url {
  font-size: 0.85rem;
  line-break: anywhere;
}

.CalendarGuideStep-image {
  text-align: center;
  margin: 15px 0;
  padding: 45px;
  background-color: var(--v-secondary-lighten1);

  & img {
    display: inline-block;
    width: 100%;
  }
}
</style>